import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/Accordion';
const FAQS = [{
  q: 'How long is the rental period?',
  a: 'Every flat price includes a 7-day rental. Need it longer? Extensions are available for a small daily fee — just let us know when you reserve.'
}, {
  q: 'What can I put in the dumpster?',
  a: "Most household junk, renovation debris, furniture, and construction materials are fine. We can't accept hazardous waste, paint, tires, batteries, or refrigerants."
}, {
  q: 'Do I need to be home for delivery?',
  a: "No. As long as we have clear access and placement instructions, you don't need to be present for drop-off or pickup."
}, {
  q: 'How do payments work?',
  a: 'You can pay in full by credit card when you reserve, or place a card on file to secure your reservation and pay with cash when the dumpster is delivered.'
}, {
  q: 'Where do you deliver?',
  a: "We serve the greater metro area and surrounding communities. Enter your delivery address during checkout and we'll confirm availability."
}];
export function FAQ() {
  return <section id="faq" className="w-full bg-background py-16 md:py-24" data-id="element-153">
      <div className="container max-w-3xl" data-id="element-154">
        <div className="text-center" data-id="element-155">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-156">
            Frequently asked questions
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-157">
            Everything you need to know before you book.
          </p>
        </div>

        <Accordion type="single" defaultValue="item-0" className="mt-10" data-id="element-158">
          {FAQS.map((item, i) => <AccordionItem key={item.q} value={`item-${i}`} data-id="element-159">
              <AccordionTrigger className="text-left text-base" data-id="element-160">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground" data-id="element-161">
                {item.a}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}